<template>
  <v-dialog v-model="dialogLocal" max-width="500px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>        
          {{ nodoParaCrearHijo ? `Creando subnodo para: ${nodoParaCrearHijo.name}` : 'Creando subnodo para nodo raíz' }}
        </span>
        <div v-if="bannerTipoSeleccionado" style="margin-left: 16px;">
          <img
            :src="bannerTipoSeleccionado"
            alt="Banner tipo seleccionado"
            style="max-height: 50px; max-width: 150px; object-fit: contain;"
          />
        </div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="nuevoNombreSubnodo"
          label="Nombre del subnodo"
          required
        />
        <v-select
          v-model="nuevoTipoSeleccionado"
          :items="tiposNodo"
          item-text="name"
          item-value="id"
          label="Tipo"
          clearable
          persistent-hint
        >
          <template v-slot:append-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="nuevoTipoTexto"
                  label="Crear nuevo tipo"
                  @keyup.enter="guardarSubnodo"
                />
                <v-file-input
                  v-model="nuevoTipoBanner"
                  label="Banner para nuevo tipo"
                  accept="image/*"
                  show-size
                  clearable
                />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="guardarSubnodo">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    tiposNodo: Array,
    bannerTipoSeleccionado: String,
    nodoParaCrearHijo: Object,
  },
  data() {
    return {
      nuevoNombreSubnodo: '',
      nuevoTipoSeleccionado: null,
      nuevoTipoTexto: '',
      nuevoTipoBanner: null,
      dialogLocal: false,
    }
  },
  watch: {
    dialog(newVal) {
      this.dialogLocal = newVal
    },
    dialogLocal(newVal) {
      if (!newVal) {
        this.$emit('update:dialog', false)
      }
    }
  },
  mounted() {
    this.dialogLocal = this.dialog
  },
  methods: {
    close() {
      this.$emit('update:dialog', false)
      this.resetFields()
    },
    resetFields() {
      this.nuevoNombreSubnodo = ''
      this.nuevoTipoSeleccionado = null
      this.nuevoTipoTexto = ''
      this.nuevoTipoBanner = null
    },
    guardarSubnodo() {
      if (!this.nuevoNombreSubnodo) {
        alert('El nombre es obligatorio')
        return
      }
      this.$emit('save-subnode', {
        nombre: this.nuevoNombreSubnodo,
        tipoSeleccionado: this.nuevoTipoSeleccionado,
        tipoNuevoTexto: this.nuevoTipoTexto,
        tipoNuevoBanner: this.nuevoTipoBanner
      })
      this.close()
    }
  }
}
</script>
